import React from 'react';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { generateKeyForElement } from '../../../helpers/elementKeyHelper';
import { applyComponentTheme } from '../../../theme';
import { CardColumnSpanCalculator } from '../../CardGrid';
import { Grid, GridItem } from '../../Grid';
import SolidBackground from '../../SolidBackground';
import RelatedContentCard, { RelatedContentCardProps } from '../RelatedContentCard';
import { NoBackground } from '../RelatedContentCard/styles';
import { Heading, Intro, StyledCardGrid } from './styles';

export const columnSpanCalculator: CardColumnSpanCalculator = () => ({
  // mobile cards are always full-width
  tabletPortrait: 4,
  tabletLandscape: 6,
  desktop: 4,
});

export type DetailedRelatedContentWithVisibilityToggleProps = {
  heading?: string;
  intro?: string;
  displayBackground?: boolean;
  cardProps: RelatedContentCardProps[];
} & ComponentProps;

const DetailedRelatedContentWithVisibilityToggle: React.FC<DetailedRelatedContentWithVisibilityToggleProps> = ({
  heading,
  intro,
  displayBackground,
  cardProps,
  ...props
}) => {
  const Background = displayBackground ? SolidBackground : NoBackground;

  return (
    <Background>
      <div {...componentProps(props)}>
        <Grid alignLeft tabIndex={0}>
          <GridItem>
            <Heading>{heading ?? 'Related Articles'}</Heading>
            {intro && <Intro>{intro}</Intro>}
          </GridItem>
        </Grid>
        <StyledCardGrid columnSpanCalculator={columnSpanCalculator} alignLeft>
          {cardProps.map((card) => (
            <RelatedContentCard
              key={generateKeyForElement(card)}
              displayBackground={displayBackground}
              {...card}
              maxLines={5}
            />
          ))}
        </StyledCardGrid>
      </div>
    </Background>
  );
};

export default applyComponentTheme(
  DetailedRelatedContentWithVisibilityToggle,
  'DetailedRelatedContentWithVisibilityToggle'
);
